export enum ROUTES {
  LOGIN = '/login',
  REGISTER = '/register',
  REGISTER_FAMILY = '/register-family',
  HOME = '/home',
  ERROR = '/error',
  MISSION = '/mission',
}
